import { IDiscountsState } from "./reducer";
const initialState: IDiscountsState = {
  discounts: [],
  isFetchingDiscounts: false,
};

export default initialState;
